import { render, staticRenderFns } from "./QuickFoodOrder.vue?vue&type=template&id=313d18de"
import script from "./QuickFoodOrder.vue?vue&type=script&lang=js"
export * from "./QuickFoodOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports